export const MAGIC_REASONABLE_UI_RESPONSE_TIME_FOR_HUMAN = 100;
export const MIN_SEARCH_CHARACTERS = 2;
export const MAX_SEARCH_CHARACTERS = 60;
export const MAX_SEARCH_RESULTS = 4;
// eslint-disable-next-line @typescript-eslint/quotes, no-template-curly-in-string
export const DEFAULT_SEARCH_ALL_TEXT = 'Search for "${input}"';
// eslint-disable-next-line no-template-curly-in-string
export const INPUT_SUBSTITUTION = "${input}";
export const DEFAULT_RESULTS_ARIA_LABEL = "Found results";
export const DEFAULT_PLACEHOLDER_TEXT = "Search";
export const DEFAULT_ENTITY = "lexuscontent";
